export default __webpack_public_path__ + "static/media/direction-arrow-left-up.d42c4a28.svg";